import type { FormSelectOption } from '@asseco/react-native-gov-components';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '../../definitions/codes';

interface SelectOptions {
	POHLAVI_OPTIONS: FormSelectOption[];
	OMEZENI_SVEPRAVNOSTI_OPTIONS: FormSelectOption[];
	RODINNY_STAV_PARTNERSTVI_OPTIONS: FormSelectOption[];
}

export const useSelectOptions = (): SelectOptions => {
	const { t } = useLocale(PageCode['profil-ROB']);

	return {
		POHLAVI_OPTIONS: [
			{
				label: t('formular.placeholders.pohlavi'),
				value: '',
			},
			{
				label: t('zaznam.pohlavi-moznosti.muz'),
				value: 'muz',
			},
			{
				label: t('zaznam.pohlavi-moznosti.zena'),
				value: 'zena',
			},
		],
		OMEZENI_SVEPRAVNOSTI_OPTIONS: [
			{
				label: t('formular.placeholders.omezeni-svepravnosti'),
				value: '',
			},
			{
				label: t('zaznam.omezeni-svepravnosti-status.ano'),
				value: 'ano',
			},
			{
				label: t('zaznam.omezeni-svepravnosti-status.ne'),
				value: 'ne',
			},
		],
		RODINNY_STAV_PARTNERSTVI_OPTIONS: [
			{
				label: t('formular.placeholders.rodinny-stav-partnerstvi'),
				value: '',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.SVOBODNY-SVOBODNA'),
				value: 'SVOBODNY/SVOBODNA',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.ZENATY-VDANA'),
				value: 'ZENATY/VDANA',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.ROZVEDENY-ROZVEDENA'),
				value: 'ROZVEDENY/ROZVEDENA',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.ZANIKLE-MANZELSTVI'),
				value: 'ZANIKLE MANZELSTVI',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.VDOVEC-VDOVA'),
				value: 'VDOVEC/VDOVA',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.PARTNERSTVI'),
				value: 'PARTNERSTVI',
			},
			{
				label: t(
					'zaznam.rodinny-stav-moznosti.ZANIKLE-PARTNERSTVI-ROZHODNUTIM'
				),
				value: 'ZANIKLE PARTNERSTVI ROZHODNUTIM',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.ZANIKLE-PARTNERSTVI'),
				value: 'ZANIKLE PARTNERSTVI',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.ZANIKLE-PARTNERSTVI-SMRTI'),
				value: 'ZANIKLE PARTNERSTVI SMRTI',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.ODLOUCENY-ODLOUCENA'),
				value: 'ODLOUCENY/ODLOUCENA',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.B'),
				value: 'B',
			},
			{
				label: t('zaznam.rodinny-stav-moznosti.C'),
				value: 'C',
			},
		],
	};
};
